import { ff_is_hexadecimal } from '../utils/strings';

/***
 *    ######## ########     ###    ##    ##  ######  #### ######## ####  #######  ##    ##  ######        ###    ##    ## #### ##     ##    ###    ######## ####  #######  ##    ##  ######
 *       ##    ##     ##   ## ##   ###   ## ##    ##  ##     ##     ##  ##     ## ###   ## ##    ##      ## ##   ###   ##  ##  ###   ###   ## ##      ##     ##  ##     ## ###   ## ##    ##
 *       ##    ##     ##  ##   ##  ####  ## ##        ##     ##     ##  ##     ## ####  ## ##           ##   ##  ####  ##  ##  #### ####  ##   ##     ##     ##  ##     ## ####  ## ##
 *       ##    ########  ##     ## ## ## ##  ######   ##     ##     ##  ##     ## ## ## ##  ######     ##     ## ## ## ##  ##  ## ### ## ##     ##    ##     ##  ##     ## ## ## ##  ######
 *       ##    ##   ##   ######### ##  ####       ##  ##     ##     ##  ##     ## ##  ####       ##    ######### ##  ####  ##  ##     ## #########    ##     ##  ##     ## ##  ####       ##
 *       ##    ##    ##  ##     ## ##   ### ##    ##  ##     ##     ##  ##     ## ##   ### ##    ##    ##     ## ##   ###  ##  ##     ## ##     ##    ##     ##  ##     ## ##   ### ##    ##
 *       ##    ##     ## ##     ## ##    ##  ######  ####    ##    ####  #######  ##    ##  ######     ##     ## ##    ## #### ##     ## ##     ##    ##    ####  #######  ##    ##  ######
 */
/***
 *     #####    ##    ####  ######    #       ####    ##   #####       ##   #    # # #    #   ##   ##### #  ####  #    #
 *     #    #  #  #  #    # #         #      #    #  #  #  #    #     #  #  ##   # # ##  ##  #  #    #   # #    # ##   #
 *     #    # #    # #      #####     #      #    # #    # #    #    #    # # #  # # # ## # #    #   #   # #    # # #  #
 *     #####  ###### #  ### #         #      #    # ###### #    #    ###### #  # # # #    # ######   #   # #    # #  # #
 *     #      #    #  ####  ######    ######  ####  #    # #####     #    # #    # # #    # #    #   #   #  ####  #    #
 */
ff_animations.register_page_load_animation((data) => {

  // ===================================================================================
  // Retire la transition sur l'élément HTML pour que le changement d'arrière-plan (En CSS) se fasse instantannément
  // ===================================================================================
  gsap.set('html', { transition: 'none' });

  // ===================================================================================
  // Intialisation de l'animation
  // ===================================================================================
  const tl = gsap.timeline({
    onStart: () => {
      if (ff_scroll) ff_scroll.lock_scroll();
      $(document).trigger('ff-first-load-anim-start');
      $('html').addClass('first-load-anim-started');
      setTimeout(() => {
        gsap.set('html', { clearProps: 'transition' }); // Remet la transition sur l'élément HTML
      });
    },
    onComplete: () => {
      $(document).trigger('ff-first-load-anim-complete');
      $('html').removeClass('first-load-anim-started');
      $('html').addClass('first-load-anim-completed');
    }
  });
  tl.set('body', { opacity: 1 }, 0);

  // ==============================================================
  // Animation simplifiée pour certaines pages et pour les appareils limités
  // ==============================================================
  const simplified_anim_namespaces = ['template-cart', 'template-checkout'];
  if (limit_animations || simplified_anim_namespaces.includes(data.next.namespace)) {
    tl.set('html', { transition: 'none' }, 0.25);
    if (limit_animations) {
      tl.fromTo('html', { backgroundColor: '#f0eb65' }, { backgroundColor: '#f0ebe8', duration: 0.65, ease: 'power3.inOut', clearProps: 'transition,backgroundColor' }, 0.25);
    }
    tl.fromTo('main, .header, .footer', { opacity: 0 }, { opacity: 1, duration: 1.3, ease: 'custom.inOutSlowOut' }, 0.25);
    tl.call(() => ff_scroll.unlock_scroll(), null, 0.6);
    return tl;
  }

  // ===================================================================================
  // Préparation du soleil approprié selon la situation
  // ===================================================================================
  const overlay = $('.page-load-overlay').get(0);
  const overlay_sun = $(overlay).find('.sun').get(0);

  // Si un soleil à animer est présent dans le premier fold, on le prépare à l'animation
  // On le wrap dans un div et reset certains styles pour animer le wrapper par la suite
  // On fait ça pour éviter d'avoir des conflits avec d'autres animations
  const section_sun_element = $('.home-introduction__sun, .about-presentation__sun').get(0);
  let section_sun_element_container;
  let section_sun_element_from_rect;
  let section_sun_element_to_rect;
  if (section_sun_element && ScrollTrigger.isInViewport(section_sun_element)) {

    const sun_diameter = Math.sqrt((vw ** 2) + (vh ** 2)); // *Diagonale de l'écran
    section_sun_element_to_rect = section_sun_element.getBoundingClientRect();
    $(section_sun_element)
      .css({
        top          : 'auto',
        left         : 'auto',
        bottom       : 'auto',
        right        : 'auto',
        pointerEvents: 'none'
      })
      .wrap('<div></div>');
    gsap.set(section_sun_element, { '--sun_diameter': () => `${sun_diameter}px` });

    section_sun_element_container = $(section_sun_element).parent().get(0);
    $(section_sun_element_container).css({
      position: 'absolute',
      left    : (vw / 2) - (sun_diameter / 2),
      top     : (vh / 2) - (sun_diameter / 2),
      zIndex  : 100
    });
    section_sun_element_from_rect = section_sun_element.getBoundingClientRect();
    gsap.set('main', { opacity: 1 });
    gsap.set($(section_sun_element).closest('main > *').siblings(), { visibility: 'hidden' });

  }

  // Si un soleil de premier fold n'est pas présent, on prépare le soleil de l'overlay pour qu'il couvre toute l'écran
  else {
    gsap.set(overlay, { display: 'flex' });
    gsap.set(overlay_sun, { '--sun_diameter': () => `${Math.sqrt((vw ** 2) + (vh ** 2))}px` });
  }

  // ==============================================================
  // Animation du soleil approprié selon la situation
  // ==============================================================
  // Animation du soleil du premier fold (Si présent)
  if (section_sun_element_container) {
    tl.set(section_sun_element_container, { clearProps: 'zIndex' }, 0.25);
    tl.set($(section_sun_element).closest('main > *').siblings(), { clearProps: 'visibility' }, 0.25);
    tl.to(section_sun_element_container, {
      x       : section_sun_element_to_rect.x - section_sun_element_from_rect.x,
      y       : section_sun_element_to_rect.y - section_sun_element_from_rect.y,
      duration: 2.05,
      ease    : CustomEase.create('custom', 'M0,0 C0.198,0.152 0.248,0.312 0.322,0.508 0.466,0.89 0.442,1 1,1 ')
    }, 0.25);
    tl.to(section_sun_element, {
      '--sun_diameter': `${section_sun_element_to_rect.width}px`,
      duration        : 2,
      ease            : CustomEase.create('custom', 'M0,0 C0.198,0.152 0.248,0.312 0.322,0.508 0.466,0.89 0.442,1 1,1 ')
    }, '<');
    tl.call(() => {
      gsap.set(section_sun_element, { clearProps: '--sun_diameter,top,left,bottom,right,pointerEvents' });
      $(section_sun_element).unwrap();
    });
  }

  // Si un soleil du premier fold n'est pas présent, on fait une animation générique du soleil de l'overlay
  else {
    const overlay_sun_rect = overlay_sun.getBoundingClientRect();
    tl.to(overlay_sun, { scale: 0.85, duration: 1.5, ease: 'custom.inOutSlowOut' }, 0.25);
    tl.to(overlay_sun, {
      y       : () => vh - overlay_sun_rect.top - ((overlay_sun_rect.height * 0.15) / 2),
      duration: 1.6,
      ease    : CustomEase.create('custom', 'M0,0,C0.774,0,0.544,0.856,1,1')
    }, '<0.2');
    tl.set(overlay, { display: 'none' });
    tl.set({}, {}, '>0.55'); // Délai de 0.55 seconde
  }
  tl.addLabel('sun-animation-end');

  // ==============================================================
  // Animation de l'entête
  // ==============================================================
  gsap.set('.header__top-container', { transition: 'none' });
  tl.from('.header__top-container', { y: '-100%', duration: 2, ease: 'expo.out', clearProps: 'y,transition' }, 'sun-animation-end-=1.3');
  tl.from('.header__logo-part', { y: () => $('.header__top-container').innerHeight(), duration: 2, ease: 'expo.out', clearProps: 'y' }, '<');

  // ==============================================================
  // Ajout de l'animation d'entrée de page
  // ==============================================================
  const page_enter_animation = ff_animations.get_page_enter_animation(data);
  if (page_enter_animation) {
    tl.add(page_enter_animation, 'sun-animation-end-=1.2');
  }

  return tl;

});

/***
 *     #####    ##    ####  ######    #      ######   ##   #    # ######      ##   #    # # #    #   ##   ##### #  ####  #    #
 *     #    #  #  #  #    # #         #      #       #  #  #    # #          #  #  ##   # # ##  ##  #  #    #   # #    # ##   #
 *     #    # #    # #      #####     #      #####  #    # #    # #####     #    # # #  # # # ## # #    #   #   # #    # # #  #
 *     #####  ###### #  ### #         #      #      ###### #    # #         ###### #  # # # #    # ######   #   # #    # #  # #
 *     #      #    #  ####  ######    ###### ###### #    #   ##   ######    #    # #    # # #    # #    #   #   #  ####  #    #
 */
ff_animations.register_page_leave_animation(() => {

  const $overlay = $('.page-transition-overlay');
  const $overlay_bg_gradient = $overlay.find('.page-transition-overlay__bg-gradient');
  const $overlay_clip_path = $overlay.find('.page-transition-overlay__clip-path clipPath');

  const tl = gsap.timeline({
    onStart: () => {
      if (ff_scroll) ff_scroll.lock_scroll();
      $('html').addClass('page-leave-animation-playing');
    },
    onComplete: () => $('html').removeClass('page-leave-animation-playing')
  });


  // ===============================================================================================================
  // Animation du panneau de transition
  // ===============================================================================================================
  if (!limit_animations && !is_mobile) {
    tl.set($overlay, { display: 'block' });
    tl.set($overlay_clip_path.find('.page-transition-overlay__clip-path-bottom'), { transformOrigin: 'top center' });
    tl.fromTo($overlay, { opacity: 0 }, { opacity: 1, duration: 1.4, ease: 'power3.inOut' });
    tl.fromTo($overlay_clip_path, { y: -vh }, { y: 0, duration: 2.3, ease: CustomEase.create('custom', 'M0,0 C0.246,0 0.344,0.07 0.4,0.5 0.423,0.684 0.45,0.86 0.526,0.928 0.6,0.994 0.69,1 1,1 ') }, '<');
    tl.fromTo($overlay_clip_path.find('.page-transition-overlay__clip-path-bottom'), { scaleY: 0 }, { scaleY: gsap.utils.mapRange(0.55, 2.05, 1, 2.2, vw / vh), duration: 2.3, ease: 'power2.in' }, '<');
    tl.fromTo($overlay_bg_gradient, { opacity: 0 }, { opacity: 1, duration: 1.85, ease: 'custom.inOutSlowOut' }, 0.45);
    tl.fromTo($overlay_bg_gradient, { backgroundPositionY: '100%' }, { backgroundPositionY: '0%', duration: 2.3, ease: 'custom.inOutSlowOut' }, '<-0.25');
  }

  // ===============================================================================================================
  // Animation des éléments dans la page
  // ===============================================================================================================
  const about_presentation_scroll_trigger = ScrollTrigger.getById('about-presentation');

  if (!limit_animations && !is_mobile && (!about_presentation_scroll_trigger || !about_presentation_scroll_trigger.isActive)) { // *On anime seulement le translate si le ScrollTrigger de la présentation de la page "À propos" n'est pas actif (Règle le conflit entre le pinning et le transform) ou si on limite les animations
    tl.fromTo('main, .footer', { y: 0 }, { duration: 0.9, y: '-14rem', ease: 'power2.in' }, 0);
  }
  tl.fromTo('main, .footer', { opacity: 1 }, { duration: 0.8, opacity: 0, ease: CustomEase.create('custom', 'M0,0,C0.7,0,0.6,0.814,1,1') }, '<0.1');
  if (ScrollTrigger.getById('header-logo-bar-offset') && (ScrollTrigger.getById('header-logo-bar-offset').isActive || ScrollTrigger.getById('header-logo-bar-offset').progress >= 1)) {
    tl.to('.header__logo-container', { y: 0, duration: 1, ease: 'expo.inOut' }, 0);
  }
  return tl;

});

/***
 *     #####    ##    ####  ######    ###### #    # ##### ###### #####       ##   #    # # #    #   ##   ##### #  ####  #    #
 *     #    #  #  #  #    # #         #      ##   #   #   #      #    #     #  #  ##   # # ##  ##  #  #    #   # #    # ##   #
 *     #    # #    # #      #####     #####  # #  #   #   #####  #    #    #    # # #  # # # ## # #    #   #   # #    # # #  #
 *     #####  ###### #  ### #         #      #  # #   #   #      #####     ###### #  # # # #    # ######   #   # #    # #  # #
 *     #      #    #  ####  ######    ###### #    #   #   ###### #    #    #    # #    # # #    # #    #   #   #  ####  #    #
 */
ff_animations.register_page_enter_animation((data) => {

  // =======================================================
  // Initialisation
  // =======================================================
  const tl = gsap.timeline({
    onStart: () => {
      $('html').addClass('page-enter-animation-playing');
      $(document).trigger('ff-page-enter-anim-start');
      if (!$('.ff-popup--is-modal.ff-popup--is-open, .ff-popup--is-modal.ff-popup--is-opening').get(0)) {
        ff_scroll.unlock_scroll();
      }
    },
    onComplete: () => {
      $('html').removeClass('page-enter-animation-playing');
      $(document).trigger('ff-page-enter-anim-complete');
      ScrollTrigger.refresh();
    }
  });

  // ==============================================================
  // Animation simplifiée pour les appareils limités
  // ==============================================================
  if (limit_animations) {
    tl.fromTo('main, .footer', { opacity: 0 }, { opacity: 1, duration: 1.3, ease: 'custom.inOutSlowOut' });
    return tl;
  }

  // =======================================================
  // Cache l'overlay de transition de page si on est dans l'animation de transition de page
  // =======================================================
  if (data.current.container) {
    tl.to('.page-transition-overlay', { opacity: 0, duration: 1.35, ease: 'custom.inOutSlowOut' });
  }

  // =======================================================
  // Va chercher la bonne animation selon l'introduction affichée dans la page
  // =======================================================
  let introduction_animation;
  const introductions_animation_map = { // Map des IDs d'animation par classe CSS (Les paramètres de l'animation peuvent être passé si la valeur est un tableau)
    '.introduction'             : 'introduction',
    '.home-introduction'        : ['home-introduction', $('html').hasClass('first-load-anim-completed')],
    '.search-field-introduction': 'search-field-introduction',
    '.about-presentation'       : ['about-presentation', $('html').hasClass('first-load-anim-completed')],
    '.catalogue'                : 'catalogue',
    '.book-introduction'        : 'book-introduction',
    '.article-media'            : 'article-media',
    '.search'                   : 'search-section'
  };
  const introduction_element = $(Object.keys(introductions_animation_map).join(', ')).get(0);
  if (introduction_element && ScrollTrigger.isInViewport(introduction_element)) {
    const introduction_animation_entry = Object.entries(introductions_animation_map).find(([selector]) => $(introduction_element).is(selector));
    const introduction_animation_id = Array.isArray(introduction_animation_entry[1]) ? introduction_animation_entry[1][0] : introduction_animation_entry[1];
    const introduction_animation_parameters = Array.isArray(introduction_animation_entry[1]) ? introduction_animation_entry[1].slice(1) : [];
    introduction_animation = introduction_animation_id ? ff_animations.get_animation(introduction_animation_id, introduction_element, ...introduction_animation_parameters) : null;
  }

  // =======================================================
  // Étapes de l'animation
  // =======================================================
  tl.set('main', { opacity: 1 }, 0);
  tl.set('.footer', { clearProps: 'y' }, 0);
  tl.to('.footer', { opacity: 1, duration: 1.2, ease: 'custom.inOutSlowOut' }, 0.075);

  // Animation de l'introduction
  tl.addLabel('introduction_anim_start', data.current.container ? 0.3 : 0.075);
  if (introduction_animation) {
    tl.add(introduction_animation, 'introduction_anim_start');
  }

  // Animation pour des éléments adjacents affichés dans l'écran spécifiques
  if ($('.articles-showcase').get(0) && ScrollTrigger.isInViewport($('.articles-showcase').get(0))) {
    tl.add(ff_animations.get_animation('articles-showcase', $('.articles-showcase').get(0), true), 'introduction_anim_start+=0.2');
  }

  // Animation générale des éléments adjacents qui sont affichés dans l'écran
  const $adjacents_elements = $('main > *').not(introduction_element).not('.articles-showcase').filter((i, adjacent_element) => ScrollTrigger.isInViewport(adjacent_element));
  if ($adjacents_elements.length != 0) {
    tl.from($adjacents_elements, { opacity: 0, duration: 1.1, ease: 'custom.inOutSlowOut', stagger: 0.09, clearProps: 'opacity' }, 'introduction_anim_start+=0.4');
  }
  return tl;

});


/***
 *    ######## ##       ######## ##     ## ######## ##    ## ########  ######        ###    ##    ## #### ##     ##    ###    ######## ####  #######  ##    ##  ######
 *    ##       ##       ##       ###   ### ##       ###   ##    ##    ##    ##      ## ##   ###   ##  ##  ###   ###   ## ##      ##     ##  ##     ## ###   ## ##    ##
 *    ##       ##       ##       #### #### ##       ####  ##    ##    ##           ##   ##  ####  ##  ##  #### ####  ##   ##     ##     ##  ##     ## ####  ## ##
 *    ######   ##       ######   ## ### ## ######   ## ## ##    ##     ######     ##     ## ## ## ##  ##  ## ### ## ##     ##    ##     ##  ##     ## ## ## ##  ######
 *    ##       ##       ##       ##     ## ##       ##  ####    ##          ##    ######### ##  ####  ##  ##     ## #########    ##     ##  ##     ## ##  ####       ##
 *    ##       ##       ##       ##     ## ##       ##   ###    ##    ##    ##    ##     ## ##   ###  ##  ##     ## ##     ##    ##     ##  ##     ## ##   ### ##    ##
 *    ######## ######## ######## ##     ## ######## ##    ##    ##     ######     ##     ## ##    ## #### ##     ## ##     ##    ##    ####  #######  ##    ##  ######
 */
/***
 *      ####  ###### #    # ###### #####  #  ####     ##### # ##### #      ######
 *     #    # #      ##   # #      #    # # #    #      #   #   #   #      #
 *     #      #####  # #  # #####  #    # # #           #   #   #   #      #####
 *     #  ### #      #  # # #      #####  # #           #   #   #   #      #
 *      ####  ###### #    # ###### #    # #  ####       #   #   #   ###### ######
 */
ff_animations.register_animation('generic-title', (element) => {
  const split_text = new SplitText(element, {
    type: 'lines'
  });
  $(element).css({
    display      : 'flex', // Désactive la fusion des marges du offset plus bas
    flexDirection: 'column' // *
  });
  $(split_text.lines)
    .css({
      margin  : '-0.08em 0 -0.1em', // Offset pour s'assurer de ne pas couper les accents
      overflow: 'hidden'
    })
    .wrapInner('<div></div>')
    .find('div')
    .css({
      padding: '0.08em 0 0.1em'
    });
  const tl = gsap.timeline({
    onComplete: () => {
      $(window).one('resize', () => split_text.revert());
    }
  });
  tl.from($(split_text.lines).find('div'), { opacity: 0.7, stagger: 0.1, duration: 1.4, ease: 'power4.out' });
  tl.fromTo($(split_text.lines).find('div'), { y: '100%' }, { y: 0, stagger: 0.1, duration: 2.2, ease: 'expo.out' }, '<');
  return tl;
});

/***
 *      ####  ###### #    # ###### #####  #  ####      ####  #      # #####  ######    # #    #
 *     #    # #      ##   # #      #    # # #    #    #      #      # #    # #         # ##   #
 *     #      #####  # #  # #####  #    # # #          ####  #      # #    # #####     # # #  #
 *     #  ### #      #  # # #      #####  # #              # #      # #    # #         # #  # #
 *      ####  ###### #    # ###### #    # #  ####      ####  ###### # #####  ######    # #    #
 */
ff_animations.register_animation('generic-slide-in', (element, origin = 'bottom') => {

  // Gestion de l'origine
  origin = ['top', 'bottom', 'left', 'right'].includes(origin) ? origin : 'bottom';
  const translate_prop = origin == 'top' || origin == 'bottom' ? 'y' : 'x';
  const translate_factor = origin == 'top' || origin == 'left' ? -1 : 1;

  // Animations
  const tl = gsap.timeline();
  tl.fromTo(element, { [translate_prop]: `${3 * translate_factor}rem` }, { [translate_prop]: 0, duration: 1.8, ease: 'expo.out', stagger: 0.09, clearProps: 'transform,opacity' });
  tl.fromTo(element, { opacity: 0 }, { opacity: 1, duration: 0.9, ease: 'custom.inOutSlowOut', stagger: 0.09 }, '<');
  return tl;

});

/***
 *     #    # #   #  ####  # #    # #   #  ####
 *     #    #  # #  #      # #    #  # #  #    #
 *     #    #   #    ####  # #    #   #   #
 *     # ## #   #        # # # ## #   #   #  ###
 *     #    #   #    ####  # #    #   #    ####
 */
ff_animations.register_animation('wysiwyg', (element, h1_generic_title_animation = true) => {
  const tl = gsap.timeline();
  const title = h1_generic_title_animation ? $(element).find('> h1').get(0) : null;
  if (title) {
    tl.add(ff_animations.get_animation('generic-title', title));
  }
  if ($(element).find('> *').not(title).length !== 0) {
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('> *').not(title)), title ? '<+0.4' : 0);
  }
  return tl;
});

/***
 *      ####    ##   #####  #####
 *     #    #  #  #  #    # #    #
 *     #      #    # #    # #    #
 *     #      ###### #####  #    #
 *      ####  #    # #    # #####
 */
ff_animations.register_animation('card', (element) => {
  const tl = gsap.timeline();
  tl.fromTo('.card__thumbnail', { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 1.4, ease: 'expo.out' });
  tl.fromTo('.card__thumbnail-inner', { scale: 1.4 }, { scale: 1, duration: 1.6, ease: 'expo.out' }, '<');
  tl.fromTo('.card__title', { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'expo.out' }, '<+0.6');
  if ($(element).find('> .u-tag').get(0)) {
    $(element).find('> .u-tag').wrapInner('<span style="display: inline-block;"></span>');
    tl.fromTo($(element).find('> .u-tag'), { clipPath: 'inset(0 100% 0 0 round .35em)' }, { clipPath: 'inset(0 0% 0 0 round .35em)', duration: 0.8, ease: 'expo.out', clearProps: 'clipPath' }, 0.2);
    tl.from($(element).find('> .u-tag > span'), { x: '90%', scale: 0.7, duration: 0.8, ease: 'expo.out', onComplete: () => $(element).find('> .u-tag > span').contents().unwrap() }, '<');
  }
  return tl;
});

/***
 *      ####    ##   #####  #####   ####      ####  #####  # #####
 *     #    #  #  #  #    # #    # #         #    # #    # # #    #
 *     #      #    # #    # #    #  ####     #      #    # # #    #
 *     #      ###### #####  #    #      #    #  ### #####  # #    #
 *      ####  #    # #    # #####   ####      ####  #    # # #####
 */
ff_animations.register_animation('cards-grid', (element) => {
  const tl = gsap.timeline();
  const on_screen_cards = $(element).find('.card').toArray().filter((grid_item) => ScrollTrigger.isInViewport(grid_item, -15));
  on_screen_cards.forEach((card, card_i) => {
    tl.add(ff_animations.get_animation('card', card), card_i * 0.1);
  });
  return tl;
});

/***
 *     # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_animation('introduction', (element) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('wysiwyg', $(element).find('.introduction__text')));
  if ($(element).find('.introduction__image').get(0)) {
    tl.fromTo('.introduction__image', { clipPath: (i, target) => `inset(60% 50% round ${$(target).innerWidth()}px)`, y: '-12rem' }, { clipPath: (i, target) => `inset(0% 0% round ${$(target).innerWidth()}px)`, y: 0, duration: 1.6, ease: 'expo.out', clearProps: 'y,clipPath' }, 0);
    tl.from('.introduction__image img', { scale: 1.4, y: '-4rem', duration: 2, ease: 'expo.out', clearProps: 'y' }, '<');
  }
  return tl;
});

/***
 *     #    #  ####  #    # ######    # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #    # #    # ##  ## #         # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     ###### #    # # ## # #####     # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     #    # #    # #    # #         # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     #    #  ####  #    # ######    # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_animation('home-introduction', (element, animate_sun = true) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('wysiwyg', $(element).find('.home-introduction__text')), 0);
  if (animate_sun) {
    tl.from('.home-introduction__sun', { top: () => vh + ff_scroll.get_scroll_top(), duration: 2.4, ease: 'expo.out', clearProps: 'top' }, 0.1);
  }
  return tl;
});

/***
 *     #####   ####   ####  #    #    # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #    # #    # #    # #   #     # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     #####  #    # #    # ####      # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     #    # #    # #    # #  #      # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     #####   ####   ####  #    #    # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_animation('book-introduction', (element) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.book-introduction__categories, .book-introduction__title, .book-introduction__navigation, .book-introduction__images, .book-introduction__promotion, .book-introduction__add-to-cart-buttons')));
  return tl;
});

/***
 *      ####  ######   ##   #####   ####  #    #    ###### # ###### #      #####     # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #      #       #  #  #    # #    # #    #    #      # #      #      #    #    # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *      ####  #####  #    # #    # #      ######    #####  # #####  #      #    #    # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *          # #      ###### #####  #      #    #    #      # #      #      #    #    # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *      ####  ###### #    # #    #  ####  #    #    #      # ###### ###### #####     # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_animation('search-field-introduction', (element) => {
  const tl = gsap.timeline();
  const authors_list = $('.authors-list').get(0);
  const collaborators_list = $('.collaborators-list').get(0);
  tl.add(ff_animations.get_animation('wysiwyg', $(element).find('.search-field-introduction__text')));
  tl.set('.search-field-introduction__form .form__input-ctn', { transformOrigin: 'left center' }, '<');
  tl.fromTo('.search-field-introduction__form .form__input-ctn', { scaleX: 0 }, { scaleX: 1, duration: 1.2, ease: 'expo.inOut' }, '<');
  tl.fromTo('.search-field-introduction__form .form__field, .search-field-introduction__form .form__input-submit-button', { opacity: 0 }, { opacity: 1, duration: 0.6, ease: 'custom.inOutSlowOut', clearProps: 'opacity' }, '>-0.2');
  if (authors_list && ScrollTrigger.isInViewport(authors_list)) {
    tl.add(ff_animations.get_animation('authors-list', authors_list).timeScale(0.6), '<-0.4');
  }
  if (collaborators_list && ScrollTrigger.isInViewport(collaborators_list)) {
    tl.add(ff_animations.get_animation('collaborators-list', collaborators_list), '<-0.4');
  }
  return tl;
});

/***
 *       ##   #####   ####  #    # #####    #####  #####  ######  ####  ###### #    # #####   ##   ##### #  ####  #    #
 *      #  #  #    # #    # #    #   #      #    # #    # #      #      #      ##   #   #    #  #    #   # #    # ##   #
 *     #    # #####  #    # #    #   #      #    # #    # #####   ####  #####  # #  #   #   #    #   #   # #    # # #  #
 *     ###### #    # #    # #    #   #      #####  #####  #           # #      #  # #   #   ######   #   # #    # #  # #
 *     #    # #####   ####   ####    #      #      #    # ######  ####  ###### #    #   #   #    #   #   #  ####  #    #
 */
ff_animations.register_animation('about-presentation', (element, animate_sun = false) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.about-presentation__screen:first-child .wysiwyg')));
  if (animate_sun) {
    tl.from('.about-presentation__sun', { top: (i, target) => -$(target).innerHeight(), duration: 2.4, ease: 'expo.out', clearProps: 'top' }, 0.1);
  }
  return tl;
});

/***
 *      ####    ##   #####   ##   #       ####   ####  #    # ######
 *     #    #  #  #    #    #  #  #      #    # #    # #    # #
 *     #      #    #   #   #    # #      #    # #      #    # #####
 *     #      ######   #   ###### #      #    # #  ### #    # #
 *      ####  #    #   #   #    # ######  ####   ####   ####  ######
 */
ff_animations.register_animation('catalogue', (element) => {
  const tl = gsap.timeline();
  const on_screen_books = $(element).find('.book').toArray().filter((book_element) => ScrollTrigger.isInViewport(book_element));
  tl.from('.catalogue__navigation-item a', { y: '105%', duration: 1.4, ease: 'expo.out', stagger: 0.09 });
  if (is_phone_display) {
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.catalogue__phone-navigation')), 0);
  }
  else {
    tl.from('.catalogue__side-border', { scaleY: 0, duration: 1.4, ease: 'expo.inOut' }, 0);
  }
  tl.add(ff_animations.get_animation('generic-slide-in', on_screen_books), 0);
  return tl;
});

/***
 *       ##   #####  ##### #  ####  #      ######  ####      ####  #    #  ####  #    #  ####    ##    ####  ######
 *      #  #  #    #   #   # #    # #      #      #         #      #    # #    # #    # #    #  #  #  #      #
 *     #    # #    #   #   # #      #      #####   ####      ####  ###### #    # #    # #      #    #  ####  #####
 *     ###### #####    #   # #      #      #           #         # #    # #    # # ## # #      ######      # #
 *     #    # #    #   #   #  ####  ###### ######  ####      ####  #    #  ####  #    #  ####  #    #  ####  ######
 */
ff_animations.register_animation('articles-showcase', (element, animate_filters = false) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('cards-grid', $(element).find('.articles-showcase__articles').get(0)));
  tl.fromTo('.articles-showcase__no-item-notice', { y: '5rem', opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: 'expo.out' }, 0);
  if (animate_filters) {
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.filters-form .form__input-ctn'), 'top'), 0);
  }
  return tl;
});

/***
 *       ##   #####  ##### #  ####  #      ######    #    # ###### #####  #   ##
 *      #  #  #    #   #   # #    # #      #         ##  ## #      #    # #  #  #
 *     #    # #    #   #   # #      #      #####     # ## # #####  #    # # #    #
 *     ###### #####    #   # #      #      #         #    # #      #    # # ######
 *     #    # #    #   #   #  ####  ###### ######    #    # ###### #####  # #    #
 */
ff_animations.register_animation('article-media', (element) => {
  const tl = gsap.timeline();
  if ($(element).find('.article-media__image').get(0)) {
    tl.from('.article-media__image', { scale: 0, y: '-3rem', duration: 1.6, ease: 'expo.out', clearProps: 'y' }, 0);
    tl.from('.article-media__image img', { scale: 3.5, y: '-4rem', duration: 2, ease: 'expo.out', clearProps: 'transform' }, '<');
  }
  tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.article-media__type')), '<+0.075');
  tl.add(ff_animations.get_animation('generic-title', $(element).find('.article-media__title span')), '<+0.075');
  if ($(element).find('.article-media__author').get(0)) {
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.article-media__author')), '<+0.075');
  }
  if (is_phone_display && $(element).find('.article-media__phone-episode').get(0)) {
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.article-media__phone-episode')), '<+0.075');
  }
  tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.article-media__media, .article-media__media-notice, .article-media__media-link')), '<+0.075');
  if (!is_phone_display && $(element).find('.article-media__episode').get(0)) {
    tl.from('.article-media__episode span', { y: '100%', duration: 1.3, ease: 'expo.out' }, '<+0.55');
  }
  return tl;
});

/***
 *       ##   #    # ##### #    #  ####  #####   ####     #      #  ####  #####
 *      #  #  #    #   #   #    # #    # #    # #         #      # #        #
 *     #    # #    #   #   ###### #    # #    #  ####     #      #  ####    #
 *     ###### #    #   #   #    # #    # #####       #    #      #      #   #
 *     #    #  ####    #   #    #  ####  #    #  ####     ###### #  ####    #
 */
ff_animations.register_animation('authors-list', (element) => {
  const tl = gsap.timeline();
  const on_screen_grid_items = $(element).find('.authors-list__grid-item').toArray().filter((grid_item) => ScrollTrigger.isInViewport(grid_item));
  on_screen_grid_items.forEach((grid_item, grid_item_i) => {
    const sub_tl = gsap.timeline();
    if ($(grid_item).hasClass('authors-list__letter-container')) {
      sub_tl.fromTo($(grid_item).find('.authors-list__letter-line'), { scaleX: 0 }, { scaleX: 1, duration: 1.2, ease: 'expo.out' });
      sub_tl.fromTo($(grid_item).find('.authors-list__letter'), { y: '-100%', rotate: -5 }, { y: 0, rotate: 0, duration: 1, ease: 'expo.out' }, '<+0.1');
    }
    else {
      sub_tl.fromTo($(grid_item).find('.authors-list__author-photo-container'), { clipPath: 'inset(0 0 100% 0)' }, { clipPath: 'inset(0 0 0% 0)', duration: 1.4, ease: 'expo.out' });
      sub_tl.fromTo($(grid_item).find('.authors-list__author-photo'), { scale: 1.4 }, { scale: 1, duration: 1.6, ease: 'expo.out' }, '<');
      sub_tl.fromTo($(grid_item).find('.authors-list__author-name'), { opacity: 0 }, { opacity: 1, duration: 0.5, ease: 'expo.out' }, '<+0.5');
    }
    tl.add(sub_tl, grid_item_i * 0.08);
  });
  if ($('.authors-list__no-item-notice').get(0)) {
    tl.fromTo('.authors-list__no-item-notice', { y: '5rem', opacity: 0 }, { y: 0, opacity: 1, duration: 1.2, ease: 'expo.out' }, 0);
  }
  return tl;
});

/***
 *      ####   ####  #      #        ##   #####   ####  #####    ##   #####  ####  #####   ####     #      #  ####  #####
 *     #    # #    # #      #       #  #  #    # #    # #    #  #  #    #   #    # #    # #         #      # #        #
 *     #      #    # #      #      #    # #####  #    # #    # #    #   #   #    # #    #  ####     #      #  ####    #
 *     #      #    # #      #      ###### #    # #    # #####  ######   #   #    # #####       #    #      #      #   #
 *      ####   ####  ###### ###### #    # #####   ####  #    # #    #   #    ####  #    #  ####     ###### #  ####    #
 */
ff_animations.register_animation('collaborators-list', (element) => {
  const tl = gsap.timeline();
  const on_screen_elements = $(element).find('.collaborators-list__letter, .collaborators-list__collaborator, .collaborators-list__letter-line').toArray().filter((grid_item) => ScrollTrigger.isInViewport(grid_item, -15));
  on_screen_elements.forEach((on_screen_element, on_screen_element_i) => {
    const position = on_screen_element_i * 0.08;
    if ($(on_screen_element).hasClass('collaborators-list__letter-line')) {
      tl.fromTo(on_screen_element, { scaleX: 0 }, { scaleX: 1, duration: 1, ease: 'expo.inOut' }, position);
    }
    else {
      tl.add(ff_animations.get_animation('generic-slide-in', on_screen_element), position);
    }
  });
  if ($('.collaborators-list__no-item-notice').get(0)) {
    tl.fromTo('.collaborators-list__no-item-notice', { y: '5rem', opacity: 0 }, { y: 0, opacity: 1, duration: 1.2, ease: 'expo.out' }, 0);
  }
  return tl;
});

/***
 *      ####  ######   ##   #####   ####  #    #     ####  ######  ####  ##### #  ####  #    #
 *     #      #       #  #  #    # #    # #    #    #      #      #    #   #   # #    # ##   #
 *      ####  #####  #    # #    # #      ######     ####  #####  #        #   # #    # # #  #
 *          # #      ###### #####  #      #    #         # #      #        #   # #    # #  # #
 *      ####  ###### #    # #    #  ####  #    #     ####  ######  ####    #   #  ####  #    #
 */
ff_animations.register_animation('search-section', (element) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('generic-title', $(element).find('.search__title-container h1')), 0);
  tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.search__form-container')), 0);
  tl.add(ff_animations.get_animation('search-results', $(element).find('.search-results')).timeScale(0.65), '<+0.15');
  tl.call(() => {
    $('html').removeClass('barba-transitioning');
  }, null, 0.5);
  return tl;
});

/***
 *      ####  ######   ##   #####   ####  #    #    #####  ######  ####  #    # #      #####  ####
 *     #      #       #  #  #    # #    # #    #    #    # #      #      #    # #        #   #
 *      ####  #####  #    # #    # #      ######    #    # #####   ####  #    # #        #    ####
 *          # #      ###### #####  #      #    #    #####  #           # #    # #        #        #
 *      ####  ###### #    # #    #  ####  #    #    #    # ######  ####   ####  ######   #    ####
 */
ff_animations.register_animation('search-results', (element) => {
  const tl = gsap.timeline();
  tl.add(ff_animations.get_animation('cards-grid', element));
  tl.fromTo('.search-results__results-type', { y: '2.25rem', opacity: 0 }, { y: 0, opacity: 1, duration: 0.9, ease: 'expo.out', stagger: 0.075 }, '<+0.2');
  tl.fromTo('.search-results__no-item-notice', { y: '5rem', opacity: 0 }, { y: 0, opacity: 1, duration: 1, ease: 'expo.out' }, 0);
  return tl;
});


/***
 *     ######   ######  ########   #######  ##       ##             ###    ##    ## #### ##     ##    ###    ######## ####  #######  ##    ##  ######
 *    ##    ## ##    ## ##     ## ##     ## ##       ##            ## ##   ###   ##  ##  ###   ###   ## ##      ##     ##  ##     ## ###   ## ##    ##
 *    ##       ##       ##     ## ##     ## ##       ##           ##   ##  ####  ##  ##  #### ####  ##   ##     ##     ##  ##     ## ####  ## ##
 *     ######  ##       ########  ##     ## ##       ##          ##     ## ## ## ##  ##  ## ### ## ##     ##    ##     ##  ##     ## ## ## ##  ######
 *          ## ##       ##   ##   ##     ## ##       ##          ######### ##  ####  ##  ##     ## #########    ##     ##  ##     ## ##  ####       ##
 *    ##    ## ##    ## ##    ##  ##     ## ##       ##          ##     ## ##   ###  ##  ##     ## ##     ##    ##     ##  ##     ## ##   ### ##    ##
 *     ######   ######  ##     ##  #######  ######## ########    ##     ## ##    ## #### ##     ## ##     ##    ##    ####  #######  ##    ##  ######
 */
/***
 *      ####  ###### #    # ###### #####  #  ####      ####  #      # #####  ######    # #    #
 *     #    # #      ##   # #      #    # # #    #    #      #      # #    # #         # ##   #
 *     #      #####  # #  # #####  #    # # #          ####  #      # #    # #####     # # #  #
 *     #  ### #      #  # # #      #####  # #              # #      # #    # #         # #  # #
 *      ####  ###### #    # ###### #    # #  ####      ####  ###### # #####  ######    # #    #
 */
// Animation d'apparition de "slide-in" pour les éléments [data-generic-slide-in] selon une valeur d'origine donnée dans l'attribut
ff_animations.register_scroll_trigger_animation('[data-generic-slide-in]', (element) => {

  if (limit_animations) return;
  const origin = $(element).attr('data-generic-slide-in') || 'bottom';

  // Bail, si l'élément possède l'attribut "data-generic-slide-in-no-touch" et on est en touch device
  if (is_touch_device && element.hasAttribute('data-generic-slide-in-no-touch')) {
    return;
  }

  // Détermine quels sont les "match medias" à donner à GSAP selon l'attribut "data-generic-slide-in-devices"
  let devices = $(element).attr('data-generic-slide-in-devices') || '';
  devices = devices.split(',').map((match_media) => match_media.trim());

  let match_media_queries = devices.map((match_media) => ({
    desktop: media_queries.desktop_only,
    tablet : media_queries.tablet_only,
    phone  : media_queries.phone_only
  }[match_media] || false)).filter(Boolean);
  match_media_queries = match_media_queries.join(', ');

  // Initialisation de l'animation
  const match_media = gsap.matchMedia();
  match_media.add(match_media_queries, () => {
    const animated_elements = element.hasAttribute('data-generic-slide-in-children') ? $(element).children() : element; // Si l'élément possède l'attribut "data-generic-slide-in-children", on anime ses éléments enfantss
    ScrollTrigger.create({
      trigger  : element,
      start    : 'top 85%',
      animation: ff_animations.get_animation('generic-slide-in', animated_elements, origin)
    });
  });

});

/***
 *      ####  ###### #    # ###### #####  #  ####     #####    ##   #####    ##   #      #        ##   #    #
 *     #    # #      ##   # #      #    # # #    #    #    #  #  #  #    #  #  #  #      #       #  #   #  #
 *     #      #####  # #  # #####  #    # # #         #    # #    # #    # #    # #      #      #    #   ##
 *     #  ### #      #  # # #      #####  # #         #####  ###### #####  ###### #      #      ######   ##
 *      ####  ###### #    # ###### #    # #  ####     #      #    # #    # #    # ###### ###### #    # #    #
 */
// Effet de parallaxe au scroll pour les éléments [data-generic-parallax] selon une valeur de mouvement optionnel donnée dans l'attribut
ff_animations.register_scroll_trigger_animation('[data-generic-parallax]', (element) => {

  if (limit_animations || is_mobile) return;

  const movement_value = parseInt($(element).attr('data-generic-parallax') || '');
  if (!movement_value) return;

  // Bail, si l'élément possède l'attribut "data-generic-parallax-no-touch" et on est en touch device
  if (is_touch_device && element.hasAttribute('data-generic-parallax-no-touch')) {
    return;
  }

  // Bail, si l'élément possède l'attribut "data-generic-parallax-no-mobile" et on est en mobile
  if (is_mobile && element.hasAttribute('data-generic-parallax-no-mobile')) {
    return;
  }

  // Détermine quels sont les "match medias" à donner à GSAP selon l'attribut "data-generic-parallax-devices"
  let devices = $(element).attr('data-generic-parallax-devices') || '';
  devices = devices.split(',').map((match_media) => match_media.trim());

  let match_media_queries = devices.map((match_media) => ({
    desktop: media_queries.desktop_only,
    tablet : media_queries.tablet_only,
    phone  : media_queries.phone_only
  }[match_media] || false)).filter(Boolean);
  match_media_queries = match_media_queries.join(', ');

  // Initialisation de l'animation
  const match_media = gsap.matchMedia();
  match_media.add(match_media_queries, () => {
    gsap.fromTo(element, { y: movement_value }, {
      y            : -movement_value,
      ease         : 'none',
      scrollTrigger: {
        trigger: element,
        start  : 'top bottom',
        end    : `bottom-=${movement_value * 2}px top`,
        scrub  : 1.3
      }
    });
    return () => {
      gsap.set(element, { clearProps: 'y' });
    };
  });

});

/***
 *     #####    ##    ####  ######    #####   ####
 *     #    #  #  #  #    # #         #    # #    #
 *     #    # #    # #      #####     #####  #
 *     #####  ###### #  ### #         #    # #  ###
 *     #      #    #  ####  ######    #####   ####
 */
ff_animations.register_scroll_trigger_animation('[data-page-bg-color]', (element) => {
  const update = (self) => {

    const bg_color = $(element).attr('data-page-bg-color');
    if (!bg_color) return;

    const other_page_bg_color_scroll_triggers = ScrollTrigger.getAll().filter((scroll_trigger) => scroll_trigger.vars.id == 'page-bg-color-trigger' && scroll_trigger.vars.trigger !== element);
    const color_already_active = other_page_bg_color_scroll_triggers.some((scroll_trigger) => {
      const scroll_trigger_bg_color = $(scroll_trigger.trigger).attr('data-page-bg-color');
      return scroll_trigger_bg_color == bg_color && scroll_trigger.isActive;
    });

    if (self.isActive) {
      $('html') // Retire toutes les autres classes d'arrière-plan de page
        .removeClass((i, class_name) => (class_name.match(/\bpage-bg-color-\S+/g) || []).join(' '))
        .css('backgroundColor', '');
    }
    if (ff_is_hexadecimal(bg_color)) { // Si une valeur hexadécimal est passée comme attribut, on applique cette couleur à l'arrière plan de la page
      $('html').css('backgroundColor', (self.isActive ? bg_color : ''));
    }
    else if (!color_already_active) {
      $('html')[self.isActive ? 'addClass' : 'removeClass'](`page-bg-color-${bg_color}`);
    }

    // Si l'élément possède l'attribut "data-page-bg-emphasis" on fade les éléments adjacents à l'élément qui sous directement des enfants du <main>
    const has_emphasis = element.hasAttribute('data-page-bg-emphasis');
    if (has_emphasis) {
      gsap.to($(element).siblings('main > *'), { opacity: (self.isActive ? 0 : 1), duration: 0.9, ease: 'custom.inOutSlowOut', clearProps: (!self.isActive ? 'opacity' : ''), overwrite: true });
      gsap.set($(element).siblings('main > *'), (self.isActive ? { pointerEvents: 'none' } : { clearProps: 'pointerEvents' }));
    }

  };
  ScrollTrigger.create({
    id             : 'page-bg-color-trigger',
    trigger        : element,
    start          : 'top center',
    end            : 'bottom center',
    refreshPriority: -1,
    onToggle       : update,
    onRefresh      : update
  });
});

/***
 *      ####  ######  ####  ##### #  ####  #    #    #    # ######   ##   #####  ###### #####
 *     #      #      #    #   #   # #    # ##   #    #    # #       #  #  #    # #      #    #
 *      ####  #####  #        #   # #    # # #  #    ###### #####  #    # #    # #####  #    #
 *          # #      #        #   # #    # #  # #    #    # #      ###### #    # #      #####
 *      ####  ######  ####    #   #  ####  #    #    #    # ###### #    # #####  ###### #    #
 */
ff_animations.register_scroll_trigger_animation('.section-header', (element) => {

  if (limit_animations) return;
  const elements = $(element).find('.section-header__text').children();

  // Animations pour chacun des éléments du texte
  gsap.matchMedia().add(`${media_queries.desktop_only}, ${media_queries.tablet_only}`, () => {
    gsap.fromTo(elements, {
      y: (i) => `-${elements.length - i}rem`
    }, {
      y            : 0,
      ease         : 'power1.out',
      scrollTrigger: {
        trigger            : '.section-header__wrapper',
        start              : `top-=${(elements.length * rem) + (4 * rem)}px bottom`,
        end                : 'center 40%',
        scrub              : 1.3,
        invalidateOnRefresh: true
      }
    });

    // Animations pour le conteneur du texte
    gsap.fromTo('.section-header__text', { y: '-4rem' }, {
      y            : 0,
      ease         : 'sine.out',
      scrollTrigger: {
        trigger            : '.section-header__wrapper',
        start              : `top-=${(elements.length * rem)}px bottom`,
        end                : 'center top',
        scrub              : 1.3,
        invalidateOnRefresh: true
      }
    });
  });

});

/***
 *     # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.introduction', (element) => {
  if (limit_animations) return;
  const tl = gsap.timeline({
    defaults     : { ease: 'none' },
    scrollTrigger: {
      trigger: element,
      start  : 0,
      scrub  : 1.3
    }
  });
  tl.fromTo('.introduction__wrapper', { y: 0 }, { y: '-6rem' }, 0);
  tl.fromTo('.introduction__image, .introduction__text > *', { y: 0 }, { y: (i, target, targets) => `${(targets.length - (i + 1)) * targets.length * -0.75}rem` }, 0);
});

/***
 *      ####  ######   ##   #####   ####  #    #    ###### # ###### #      #####     # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #      #       #  #  #    # #    # #    #    #      # #      #      #    #    # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *      ####  #####  #    # #    # #      ######    #####  # #####  #      #    #    # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *          # #      ###### #####  #      #    #    #      # #      #      #    #    # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *      ####  ###### #    # #    #  ####  #    #    #      # ###### ###### #####     # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.search-field-introduction', (element) => {
  if (limit_animations) return;
  const tl = gsap.timeline({
    defaults     : { ease: 'none' },
    scrollTrigger: {
      trigger: element,
      start  : 0,
      scrub  : 1.3
    }
  });
  tl.fromTo('.search-field-introduction__text', { y: 0 }, { y: '-6rem' }, 0);
  tl.fromTo('.search-field-introduction__text > *', { y: 0 }, { y: (i, target, targets) => `${(targets.length - (i + 1)) * targets.length * -0.75}rem` }, 0);
});

/***
 *     ##### # ##### #      ######    ##### ###### #    # #####    #    # #####
 *       #   #   #   #      #           #   #       #  #    #      ##  ## #    #
 *       #   #   #   #      #####       #   #####    ##     #      # ## # #####
 *       #   #   #   #      #           #   #        ##     #      #    # #    #
 *       #   #   #   ###### ######      #   ###### #    #   #      #    # #####
 */
ff_animations.register_scroll_trigger_animation('.title-text-mb', (element) => {
  if (limit_animations || is_mobile) return;
  gsap.matchMedia().add({
    is_not_phone: `${media_queries.desktop_only}, ${media_queries.tablet_only}`,
    is_phone    : media_queries.phone_only // On anime la ligne différamment sur les téléphones
  }, (context) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: '.title-text-mb__wrapper',
        start  : 'top 75%'
      }
    });
    tl.fromTo('.title-text-mb__line', { [context.conditions.is_phone ? 'scaleX' : 'scaleY']: 0 }, { [context.conditions.is_phone ? 'scaleX' : 'scaleY']: 1, duration: 1.6, ease: 'expo.inOut', clearProps: 'scaleY' });
    tl.add(ff_animations.get_animation('generic-title', $(element).find('.title-text-mb__title')), 0.1);
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.title-text-mb__text').children(), context.conditions.is_phone ? 'bottom' : 'right'), '<+0.1');
  });
});

/***
 *     #    #  ####  #    # ######    # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #    # #    # ##  ## #         # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     ###### #    # # ## # #####     # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     #    # #    # #    # #         # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     #    #  ####  #    # ######    # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.home-introduction', (element) => {
  if (limit_animations || is_mobile) return;
  const tl = gsap.timeline({
    defaults     : { ease: 'none' },
    scrollTrigger: {
      trigger   : element,
      endTrigger: $(element).find('.home-introduction__sun'),
      start     : 0,
      end       : 'bottom top',
      scrub     : 1.3
    }
  });
  tl.fromTo($(element).find('.home-introduction__sun'), { y: 0, scale: 1 }, { y: '-18rem', scale: 0.9 });
  tl.fromTo($(element).find('.home-introduction__text'), { y: 0, scale: 1 }, { y: '-34rem', scale: 1.1 }, 0);
  tl.fromTo($(element).find('.home-introduction__text > *'), { y: 0 }, { y: (i, target, targets) => `${(targets.length - (i + 1)) * targets.length * -3.5}rem` }, 0);
});

/***
 *     #    #  ####  #    # ######    ###### ######   ##   ##### #    # #####  ###### #####      ####   ####  #    # ##### ###### #    # #####
 *     #    # #    # ##  ## #         #      #       #  #    #   #    # #    # #      #    #    #    # #    # ##   #   #   #      ##   #   #
 *     ###### #    # # ## # #####     #####  #####  #    #   #   #    # #    # #####  #    #    #      #    # # #  #   #   #####  # #  #   #
 *     #    # #    # #    # #         #      #      ######   #   #    # #####  #      #    #    #      #    # #  # #   #   #      #  # #   #
 *     #    #  ####  #    # ######    #      ###### #    #   #    ####  #    # ###### #####      ####   ####  #    #   #   ###### #    #   #
 */
ff_animations.register_scroll_trigger_animation('.home-featured-content', (element) => {
  if (limit_animations || is_mobile) return;
  gsap.matchMedia().add(`${media_queries.desktop_only}, ${media_queries.tablet_only}`, () => {
    gsap.fromTo(element, { '--home_featured_content_slides_image_y': '4rem', '--home_featured_content_slides_text_y': '-4rem' }, {
      '--home_featured_content_slides_image_y': '-4rem',
      '--home_featured_content_slides_text_y' : '4rem',
      ease                                    : 'none',
      scrollTrigger                           : {
        trigger: $(element).find('.home-featured-content__slider'),
        scrub  : 1.3
      }
    });
    return () => {
      gsap.set(element, { clearProps: '--home_featured_content_slides_image_y,--home_featured_content_slides_image_scale' });
    };
  });
});

/***
 *     #    #  ####  #    # ######    #        ##   ##### ######  ####  #####    #####   ####   ####  #    #  ####
 *     #    # #    # ##  ## #         #       #  #    #   #      #        #      #    # #    # #    # #   #  #
 *     ###### #    # # ## # #####     #      #    #   #   #####   ####    #      #####  #    # #    # ####    ####
 *     #    # #    # #    # #         #      ######   #   #           #   #      #    # #    # #    # #  #        #
 *     #    #  ####  #    # ######    ###### #    #   #   ######  ####    #      #####   ####   ####  #    #  ####
 */
ff_animations.register_scroll_trigger_animation('.home-latest-books', (element) => {

  if (limit_animations) return;
  const $title = $(element).find('.home-latest-books__title');
  const title_span = $title.find('span').get(0);

  // Animation d'affichage du titre (Masque)
  gsap.set(title_span, { y: '100%' });

  ScrollTrigger.create({
    trigger   : element,
    endTrigger: $(element).find('.home-latest-books__books'),
    start     : 'top+=100px center',
    end       : 'center center',
    onEnter   : () => {
      gsap.killTweensOf(title_span);
      gsap.to(title_span, { y: 0, duration: 1.6, ease: 'expo.out' });
    },
    onLeaveBack: () => {
      gsap.killTweensOf(title_span);
      gsap.to(title_span, { y: '100%', duration: 0.5, ease: 'power2.in' });
    },
    onRefresh: () => {
      gsap.set(element, { '--home_latest_books_mobile_title_bottom': `${$(element).find('.book:last-child').innerHeight() / 2}px` }); // *Offset du bottom pour le sticky du titre
    }
  });

  // Animation d'affichage du titre (opacité)
  gsap.fromTo($title, { opacity: 0 }, {
    opacity      : 1,
    ease         : 'none',
    scrollTrigger: {
      trigger: element,
      start  : 'top center',
      end    : 'top+=100px center',
      scrub  : 0.15
    }
  });

  // Animations d'affichage des livres
  const books_tl = gsap.timeline({
    scrollTrigger: {
      trigger: $(element).find('.home-latest-books__books'),
      start  : 'top 80%'
    }
  });
  $(element).find('.book').each((i, book_element) => {
    books_tl.from(book_element, { y: '15rem', duration: 1.8, ease: 'expo.out' }, i * 0.275);
    books_tl.from(book_element, { opacity: 0, duration: 0.6, ease: 'power3.inOut' }, '<+0.15');
  });

});

/***
 *     #    #  ####  #    # ######      ##   #####   ####  #    # #####     ####  ######  ####  ##### #  ####  #    #
 *     #    # #    # ##  ## #          #  #  #    # #    # #    #   #      #      #      #    #   #   # #    # ##   #
 *     ###### #    # # ## # #####     #    # #####  #    # #    #   #       ####  #####  #        #   # #    # # #  #
 *     #    # #    # #    # #         ###### #    # #    # #    #   #           # #      #        #   # #    # #  # #
 *     #    #  ####  #    # ######    #    # #####   ####   ####    #       ####  ######  ####    #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.home-about-section', (element) => {

  if (limit_animations || is_mobile) return;

  // Parallaxe de l'image
  gsap.fromTo('.home-about-section__image-container', { y: '-50%' }, {
    y            : '50%',
    ease         : 'none',
    scrollTrigger: {
      trigger: element,
      scrub  : true
    }
  });

  // Parallaxe du texte et zoom sur l'image
  const tl = gsap.timeline({
    defaults     : { duration: 1, ease: 'none' },
    scrollTrigger: {
      trigger: element,
      scrub  : 1.6
    }
  });
  tl.fromTo(element, { '--home_about_section_backdrop_opacity': 0.9 }, { '--home_about_section_backdrop_opacity': 0.5, duration: 0.5 });
  tl.fromTo('.home-about-section__text', { opacity: -0.25, y: '9rem' }, { opacity: 2.4, y: '-9rem' }, '<');
  tl.fromTo('.home-about-section__image', { scale: 1 }, { scale: 1.4 }, '<');

});

/***
 *     #    #  ####  #    # ######     ####    ##   #####   ##   #       ####   ####  #    # ######
 *     #    # #    # ##  ## #         #    #  #  #    #    #  #  #      #    # #    # #    # #
 *     ###### #    # # ## # #####     #      #    #   #   #    # #      #    # #      #    # #####
 *     #    # #    # #    # #         #      ######   #   ###### #      #    # #  ### #    # #
 *     #    #  ####  #    # ######     ####  #    #   #   #    # ######  ####   ####   ####  ######
 */
ff_animations.register_scroll_trigger_animation('.home-catalogue', (element) => {

  if (is_touch_device || limit_animations) return;

  // Animation d'apparition des catégories
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: '.home-catalogue__categories',
      start  : 'top 85%'
    }
  });
  tl.fromTo('.home-catalogue__category-link', { x: '9rem' }, { x: 0, stagger: 0.09, duration: 1.8, ease: 'expo.out', clearProps: 'x,opacity' });
  tl.fromTo('.home-catalogue__category-link', { opacity: 0 }, { opacity: 1, stagger: 0.09, duration: 0.85, ease: 'custom.inOutSlowOut' }, '<');

  // Animation scrub des catégories
  gsap.matchMedia().add(media_queries.desktop_only, () => {
    const scrub_tl = gsap.timeline({
      defaults     : { ease: 'none' },
      scrollTrigger: {
        trigger: '.home-catalogue__categories',
        scrub  : 1.3
      }
    });
    scrub_tl.fromTo('.home-catalogue__category-link-container', { x: '2.25rem' }, { x: '-2.25rem' });
  });

});

/***
 *       ##   #####   ####  #    # #####    #####  #####  ######  ####  ###### #    # #####   ##   ##### #  ####  #    #
 *      #  #  #    # #    # #    #   #      #    # #    # #      #      #      ##   #   #    #  #    #   # #    # ##   #
 *     #    # #####  #    # #    #   #      #    # #    # #####   ####  #####  # #  #   #   #    #   #   # #    # # #  #
 *     ###### #    # #    # #    #   #      #####  #####  #           # #      #  # #   #   ######   #   # #    # #  # #
 *     #    # #####   ####   ####    #      #      #    # ######  ####  ###### #    #   #   #    #   #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.about-presentation', (element) => {

  // ====================================================================================
  // Animation de la section au scroll
  // ====================================================================================
  const $screens = $(element).find('.about-presentation__screen');
  const tl_defaults = { duration: 1, ease: 'none' };
  const tl = gsap.timeline({
    defaults     : tl_defaults,
    scrollTrigger: {
      id                 : 'about-presentation',
      trigger            : '.about-presentation__container',
      start              : 'top top',
      end                : () => `+=${$screens.length * (vh * (is_pointer_device ? 0.975 : 0.65))}px`,
      pin                : !limit_animations,
      pinType            : 'fixed',
      scrub              : 0.5,
      snap               : !limit_animations ? { snapTo: 'labels', delay: 0 } : false,
      invalidateOnRefresh: true
    }
  });

  // Textes
  if (!limit_animations) {
    $screens.each((i, screen) => {

      // Translate Y
      if (i == 0) { // Animation de sortie seulement pour le premier élément
        tl.addLabel(`screen_${i}_centered`);
        tl.fromTo(screen, { y: 0 }, {
          y   : '-10rem',
          ease: (value) => { // Calcule un easing pour n'avoir que la deuxième moitié du ease 'custom.slowMo'
            const ease_fct = gsap.parseEase('custom.slowMo');
            return (ease_fct(gsap.utils.mapRange(0, 1, 0.5, 1, value)) - 0.5) * 2;
          }
        });
      }
      else if (i == $screens.length - 1) { // Animation d'entrée seulement pour le dernier élément
        tl.fromTo(screen, { y: '10rem' }, {
          y   : 0,
          ease: (value) => { // Calcule un easing pour n'avoir que la première moitié du ease 'custom.slowMo'
            const ease_fct = gsap.parseEase('custom.slowMo');
            return ease_fct(gsap.utils.mapRange(0, 1, 0, 0.5, value)) * 2;
          }
        }, '>-0.05');
        tl.addLabel(`screen_${i}_centered`, '>');
      }
      else {
        tl.fromTo(screen, { y: '10rem' }, { y: '-10rem', ease: 'custom.slowMo', duration: tl_defaults.duration * 2 }, '>-0.05');
        tl.addLabel(`screen_${i}_centered`, `<+${tl_defaults.duration}`);
      }

      // Opacité
      tl.call(() => gsap.set(screen, { pointerEvents: tl.scrollTrigger.direction == 1 ? 'auto' : 'none' }), null, '<');
      if (i != 0) {
        tl.fromTo(screen, { opacity: 0 }, { opacity: 1, ease: 'power1.out' }, '<');
      }
      if (i != $screens.length - 1) {
        tl.to(screen, { opacity: 0, ease: 'power1.in' }, i == 0 ? '<' : '>');
        tl.call(() => gsap.set(screen, { pointerEvents: tl.scrollTrigger.direction == 1 ? 'none' : 'auto' }), null, '>');
      }


    });
  }

  // Soleil
  tl.to('.about-presentation__sun', { x: () => (is_phone_display ? '105vw' : '45vw'), y: () => (is_phone_display ? '80vh' : '95vh'), duration: () => tl.duration() + 0.3, ease: 'custom.inOutSlowOut' }, 0);

  const sun_color_animation_delay = tl.duration() * 0.15;
  tl.fromTo(
    '.about-presentation__sun',
    { '--sun_top_color': gsap.getProperty('.about-presentation__sun', '--sun_color'), '--sun_bottom_color': gsap.getProperty('.about-presentation__sun', '--sun_color') },
    { '--sun_top_color': '#FFAAB1', '--sun_bottom_color': '#FFAAB1', duration: () => (tl.duration() - sun_color_animation_delay) / 3, ease: 'none' },
    sun_color_animation_delay
  );
  tl.to('.about-presentation__sun', { '--sun_top_color': '#FF7F8A', '--sun_bottom_color': '#FF7F8A', duration: () => (tl.duration() - sun_color_animation_delay) / 3, ease: 'none' }, '>');
  tl.to('.about-presentation__sun', { '--sun_top_color': '#FF6C78', '--sun_bottom_color': '#FFB5BB', duration: () => (tl.duration() - sun_color_animation_delay) / 3, ease: 'power1.out' }, '>');

  // Arrière-plan
  tl.fromTo('.about-presentation__bg', { opacity: 0 }, { opacity: 1, duration: () => tl.duration() / 2, ease: 'none', overwrite: true }, 0);
  tl.to('.about-presentation__bg', { backgroundPositionY: '0%', duration: () => tl.duration() / 2, ease: 'power1.out' }, '>');

  // ====================================================================================
  // Fade out des éléments lorsque l'animation de la section est terminé
  // ====================================================================================
  const out_tl = gsap.timeline({
    defaults     : tl_defaults,
    scrollTrigger: {
      trigger            : element,
      start              : 'bottom 120%',
      end                : !limit_animations ? 'bottom 10%' : 'bottom 70%',
      scrub              : 1,
      invalidateOnRefresh: true
    }
  });
  out_tl.to('.about-presentation__bg-container, .about-presentation__sun-container', { opacity: 0 });
  if (!limit_animations) {
    out_tl.to('.about-presentation__sun-container', { y: '-=24rem', ease: 'power1.in' }, 0);
    out_tl.to('.about-presentation__screens-container', { top: '-=8rem', ease: 'sine.in' }, 0);
  }

});

/***
 *       ##   #    # ##### #    #  ####  #####   ####     #      #  ####  #####
 *      #  #  #    #   #   #    # #    # #    # #         #      # #        #
 *     #    # #    #   #   ###### #    # #    #  ####     #      #  ####    #
 *     ###### #    #   #   #    # #    # #####       #    #      #      #   #
 *     #    #  ####    #   #    #  ####  #    #  ####     ###### #  ####    #
 */
ff_animations.register_scroll_trigger_animation('.authors-list', (element) => {
  if (limit_animations || is_mobile) return;
  const $grid_elements = $(element).find('.authors-list__grid-item').filter((i, grid_item) => !ScrollTrigger.isInViewport(grid_item)); // On anime seulement les éléments qui ne sont pas visibles dans le viewport
  $grid_elements.each((i, grid_item) => {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger            : grid_item,
        start              : '-30% bottom',
        invalidateOnRefresh: true
      }
    });
    tl.fromTo(grid_item, { opacity: 0.3 }, { opacity: 1, duration: 0.8, ease: 'custom.inOutSlowOut' });
    tl.fromTo(grid_item, { y: '45%' }, { y: 0, duration: 2.4, ease: 'expo.out' }, '<');
  });
});

/***
 *     #####   ####   ####  #    #    # #    # ##### #####   ####  #####  #    #  ####  ##### #  ####  #    #
 *     #    # #    # #    # #   #     # ##   #   #   #    # #    # #    # #    # #    #   #   # #    # ##   #
 *     #####  #    # #    # ####      # # #  #   #   #    # #    # #    # #    # #        #   # #    # # #  #
 *     #    # #    # #    # #  #      # #  # #   #   #####  #    # #    # #    # #        #   # #    # #  # #
 *     #####   ####   ####  #    #    # #    #   #   #    #  ####  #####   ####   ####    #   #  ####  #    #
 */
ff_animations.register_scroll_trigger_animation('.book-introduction', (element) => {
  if (limit_animations) return;
  const tl = gsap.timeline({
    defaults     : { ease: 'none' },
    scrollTrigger: {
      trigger: element,
      start  : 0,
      scrub  : 1.3
    }
  });
  tl.fromTo('.book-introduction__wrapper', { y: 0 }, { y: '-6rem' }, 0);
  tl.fromTo('.book-introduction__title-container, .book-introduction__images-wrapper, .book-introduction__navigation > ul', { y: 0 }, { y: (i, target, targets) => `${(targets.length - (i)) * targets.length * -1}rem` }, 0);
});

/***
 *     #####   ####   ####  #    #    #    #  ####   ####  #    #     ####  ###### #    # ##### ###### #    #  ####  ######
 *     #    # #    # #    # #   #     #    # #    # #    # #   #     #      #      ##   #   #   #      ##   # #    # #
 *     #####  #    # #    # ####      ###### #    # #    # ####       ####  #####  # #  #   #   #####  # #  # #      #####
 *     #    # #    # #    # #  #      #    # #    # #    # #  #           # #      #  # #   #   #      #  # # #      #
 *     #####   ####   ####  #    #    #    #  ####   ####  #    #     ####  ###### #    #   #   ###### #    #  ####  ######
 */
ff_animations.register_scroll_trigger_animation('.book-hook-sentence', (element) => {

  // ============================================================================
  // Animation pour appareils limités
  // ============================================================================
  if (limit_animations || is_mobile) {
    gsap.fromTo($(element).find('blockquote'), { opacity: 0 }, {
      opacity      : 1,
      duration     : 1.4,
      ease         : 'custom.inOutSlowOut',
      scrollTrigger: {
        trigger      : element,
        start        : 'top center',
        end          : 'bottom center',
        toggleActions: 'play reverse play reverse'
      }
    });
    return;
  }

  // ============================================================================
  // Animation normale
  // ============================================================================
  let tl;

  // Initialise le SplitText du blockquote
  const blockquote_split_text = new SplitText($(element).find('blockquote'), { type: 'lines' });
  const initial_vw = window.innerWidth;
  const resize_handler = $.debounce(() => {
    if (initial_vw == window.innerWidth) return;
    blockquote_split_text.revert();
    tl.revert();
    gsap.set('.book-hook-sentence__wrapper', { clearProps: 'opacity' });
    $(window).off('resize', resize_handler);
  }, 200);
  $(window).on('resize', resize_handler);// Lors d'un resize de la largeur de l'écran, on revert le SplitText et la timeli

  // Animation
  const on_leave_cb = () => gsap.to('.book-hook-sentence__wrapper', { opacity: 0, duration: 1, ease: 'custom.inOutSlowOut', overwrite: true, onComplete: () => tl.pause(0) }); // eslint-disable-line no-use-before-define
  const on_enter_cb = ({ animation }) => {
    if (gsap.getProperty('.book-hook-sentence__wrapper', 'opacity') == 1) return;
    gsap.killTweensOf('.book-hook-sentence__wrapper');
    if (animation.progress() == 1) {
      gsap.to('.book-hook-sentence__wrapper', { opacity: 1, duration: 1, ease: 'custom.inOutSlowOut', overwrite: true });
    }
    else {
      gsap.set('.book-hook-sentence__wrapper', { clearProps: 'opacity' });
    }
  };

  tl = gsap.timeline({
    scrollTrigger: {
      trigger      : element,
      start        : 'top center',
      end          : 'bottom center',
      toggleActions: 'play none play none',
      onLeave      : on_leave_cb,
      onLeaveBack  : on_leave_cb,
      onEnter      : on_enter_cb,
      onEnterBack  : on_enter_cb
    }
  });
  tl.fromTo(blockquote_split_text.lines, { y: '3em' }, { y: 0, duration: 2.5, ease: 'power4.out', stagger: 0.1 }, 0.3);
  tl.fromTo(blockquote_split_text.lines, { opacity: 0 }, { opacity: 1, duration: 1.2, ease: 'custom.inOutSlowOut', stagger: 0.1 }, '<');

  // Initialise le ScrollTrigger qui reset la timeline lorsque le <blockquote> n'est pas dans l'écran
  ScrollTrigger.create({
    trigger    : 'blockquote',
    onLeaveBack: () => {
      gsap.killTweensOf('.book-hook-sentence__wrapper');
      gsap.set('.book-hook-sentence__wrapper', { clearProps: 'opacity' });
      tl.pause(0);
    },
    onLeave: () => {
      gsap.killTweensOf('.book-hook-sentence__wrapper');
      gsap.set('.book-hook-sentence__wrapper', { clearProps: 'opacity' });
      tl.pause(0);
    }
  });

});

/***
 *     #####   ####   ####  #    #    # #    # ######  ####  #####  #    #   ##   ##### #  ####  #    #  ####
 *     #    # #    # #    # #   #     # ##   # #      #    # #    # ##  ##  #  #    #   # #    # ##   # #
 *     #####  #    # #    # ####      # # #  # #####  #    # #    # # ## # #    #   #   # #    # # #  #  ####
 *     #    # #    # #    # #  #      # #  # # #      #    # #####  #    # ######   #   # #    # #  # #      #
 *     #####   ####   ####  #    #    # #    # #       ####  #    # #    # #    #   #   #  ####  #    #  ####
 */
ff_animations.register_scroll_trigger_animation('.book-informations', (element) => {
  if (limit_animations) return;
  gsap.matchMedia().add(`${media_queries.desktop_only}, ${media_queries.tablet_only}`, () => {
    const tl = gsap.timeline({
      invalidateOnRefresh: true,
      scrollTrigger      : {
        trigger: element,
        start  : 'top 50%'
      }
    });
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.book-informations__title, .book-informations__author'), 'left'), '<+0.1');
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.book-informations__summary, .book-informations__keywords')), '<');
    tl.add(ff_animations.get_animation('generic-slide-in', $(element).find('.book-informations__categories, .book-informations__misc-infos > *, .book-informations__misc-infos-container > p, .book-informations__links > *')), '<');
    tl.fromTo('.book-informations__col:not(:first-child)', { '--book_informations_col_line_scale': 0 }, { '--book_informations_col_line_scale': 1, duration: 1.6, ease: 'expo.inOut' }, 0.2);
  });
});

/***
 *     #    # ######   ##   #####  ###### #####
 *     #    # #       #  #  #    # #      #    #
 *     ###### #####  #    # #    # #####  #    #
 *     #    # #      ###### #    # #      #####
 *     #    # ###### #    # #####  ###### #    #
 */
// ScrollTrigger qui ajoute ou retire la classe du document ".on-sun-section" qui gère l'affichage différent pour la barre logo en fixed du header
ff_animations.register_scroll_trigger_animation('.home-introduction, .about-presentation', (element) => {
  const header_logo_container = $('.header__logo-container').get(0);
  ScrollTrigger.create({
    trigger        : element,
    refreshPriority: -1,
    start          : () => `top ${header_logo_container.getBoundingClientRect().top}px`,
    end            : () => `bottom ${header_logo_container.getBoundingClientRect().bottom}px`,
    onToggle       : (self) => $('html')[self.isActive ? 'addClass' : 'removeClass']('on-sun-section')
  });
});

// ScrollTriggers qui ajoute ou retire les classes qui donne la couleur orange aux éléments du header s'ils sont superposés avec la section "À propos" de la page d'accueil
ff_animations.register_scroll_trigger_animation('.home-about-section', (element) => {
  if (limit_animations) return;
  $('.header__burger, .header__logo-container').each((i, header_element) => { // On calcule les valeurs de triggers du scroller par rapport aux éléments du header
    ScrollTrigger.create({
      trigger : element,
      start   : () => `top ${$(header_element).position().top + ($(header_element).height() / 2)}px`,
      end     : () => `bottom ${$(header_element).position().top + ($(header_element).height() / 2)}px`,
      onToggle: (self) => {
        if ($(header_element).hasClass('header__burger')) {
          $(header_element).closest('.header__top-container')[self.isActive ? 'addClass' : 'removeClass']('header__top-container--orange');
        }
        else {
          $(header_element)[self.isActive ? 'addClass' : 'removeClass']('header__logo-container--orange');
        }
      }
    });
  });
});

// ScrollTrigger qui fait bouger la barre logo du header pour éviter la superposition des copyrights du pied de page
ff_animations.register_scroll_trigger_animation('.footer__copyrights', (element) => {
  if ($(element).is(':hidden')) return;
  const get_header_logo_bottom_offset = () => vh - $('.header__logo-container').get(0).getBoundingClientRect().bottom;
  gsap.fromTo($('.header__logo-container'), { y: 0 }, {
    y            : () => -$(element).outerHeight() + get_header_logo_bottom_offset() - parseFloat($('body').css('marginBottom')),
    ease         : 'none',
    scrollTrigger: {
      id                 : 'header-logo-bar-offset',
      trigger            : element,
      start              : () => `top bottom-=${get_header_logo_bottom_offset()}px`,
      end                : () => `bottom+=${parseFloat($('body').css('marginBottom'))}px bottom`,
      invalidateOnRefresh: true,
      scrub              : true
    }
  });
});
